// extracted by mini-css-extract-plugin
export default {"postFrom":"postForm_postFrom__-qYnv"};